import type { JSX } from 'react'
import type { ILabelProps } from 'atoms/Label'
import type { Fonts } from 'atoms/Label/Label.h'
import type { ILabelGroupProps } from '../LabelGroup'

import { LabelSecondaryRoundedTemplate } from 'atoms/Label/Templates'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate1Props extends Omit<
  ILabelGroupProps,
  'children'
> {
  list: ILabelProps['title'][]
  font?: Fonts
}

export const LabelGroupTemplate1 = ({
  list = [],
  font,
  ...rest
}: ILabelGroupTemplate1Props): JSX.Element => {
  const labels = list.filter((item) => item)

  return labels?.length > 0 ? (
    <LabelGroup {...rest}>
      {labels.map((title, i) => (
        <LabelSecondaryRoundedTemplate
          font={font}
          key={`${i}${title}`}
          title={title}
        />
      ))}
    </LabelGroup>
  ) : (
    <></>
  )
}
